const crypto = require("crypto");

export function createSignature(hexText: string) {
  let hmac = crypto.createHmac("sha256", "gedacgaavg");
  hmac.update(hexText);
  return hmac.digest("hex");
}
